<template>
  <SettingsPageLayout>
    <div>
      <div class="flex justify-end">
        <TButton label="Back" @click="$router.go(-1)" />
        <TButton class="ml-2" label="Save" color="indigo" @click="saveTemplate">
          <LocalLoadingSpinner />
        </TButton>
      </div>
      <docuseal-builder
        v-if="loaded"
        :data-token="docusealToken"
        :data-fields="fields"
        :data-roles="submitters"
        data-with-send-button="false"
        data-with-sign-yourself-button="false"
        data-with-documents-list="false"
        data-autosave="false"
        data-custom-css="#save_button { visibility: hidden; }"
      >
      </docuseal-builder>
    </div>
  </SettingsPageLayout>
</template>

<script>
import { Api } from '../../../api';
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    SettingsPageLayout,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      loaded: false,
      docusealToken: null,
      submitters: [],
      fields: [],
      title: '',
    };
  },
  async mounted() {
    const self = this;
    await self.fetchStandardAndCustomFields();
    self.getToken();
  },
  methods: {
    async fetchStandardAndCustomFields() {
      const self = this;
      const { records } = await Api.CustomFields.listCustomFields();
      self.fields.push(
        { name: '{{contact.name}}', type: 'text', title: 'Full Name', role: 'Teammate' },
        { name: '{{contact.first_name}}', type: 'text', title: 'First Name', role: 'Teammate' },
        { name: '{{contact.last_name}}', type: 'text', title: 'Last Name', role: 'Teammate' },
        { name: '{{contact.email}}', type: 'text', title: 'Email', role: 'Teammate' },
        { name: '{{contact.phone_number}}', type: 'text', title: 'Phone Number', role: 'Teammate' },
        { name: '{{team.company}}', type: 'text', title: 'Company Name', role: 'Company' }
      );
      for (let record of records) {
        self.fields.push({
          name: `{{contact.${record.key}}}`,
          type: self.getDocusealFieldType(record.field_type),
          title: record.name,
          role: 'Teammate',
        });
      }
      self.fields = JSON.stringify(self.fields);
      this.loadingSpinnerStore.hideLocalLoadingSpinner();
    },
    getDocusealFieldType(humaniz_field_type) {
      let field_type_legend = {
        short_text: 'text',
        single_option: 'text',
        multiple_options: 'text',
        date: 'date',
        number: 'text',
        percentage: 'text',
        currency: 'text',
      };
      return field_type_legend[humaniz_field_type];
    },
    getToken() {
      const self = this;
      fetch(`/api/esignature_templates/${self.$route.params.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.docusealToken = data.data.encoded_body;
          self.submitters = data.data.template.submitters.map(x => x.name);
          self.loaded = true;
          setTimeout(() => {
            document.querySelector('docuseal-builder').addEventListener('save', e => self.templateSaved());
          }, 500);
        });
    },
    saveTemplate() {
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      document.querySelector('docuseal-builder').shadowRoot.querySelector('#save_button').click();
    },
    templateSaved() {
      this.loadingSpinnerStore.hideLocalLoadingSpinner();
      toast.success('Esignature Template Saved!', {
        action: { label: 'Dismiss' },
        description: 'Your esignature template was successfully saved.  Use the button below to dismiss this alert.',
      });
    },
  },
};
</script>
